import { initGdp } from "./gio-report";
import { getClientEnv } from "./tools";
import SentryRun from "./sentry";

/**
 * 初始化方法汇总执行
 */
export const initial = ({ appName }: { appName: string }) => {
  SentryRun(appName);
  initHtmlFontSize();
  initVConsole();
  initGdp();
};

/**
 * 初始化html的fontSize，以设计稿宽度750px为基准
 */
const initHtmlFontSize = (UIWidth = 750) => {
  const screenWidth = document.documentElement.clientWidth || window.innerWidth;
  const fontSize = screenWidth / UIWidth;
  document.documentElement.style.fontSize = `${fontSize}px`;
};

/**
 * 初始化VConsole
 */
const initVConsole = () => {
  const env = getClientEnv();
  if (env !== "product") {
    import("vconsole").then((VConsole) => {
      new VConsole.default();
    });
  }
};
